import { Component, OnInit, ViewChild } from '@angular/core';
import { WfTableComponent } from '../../../common/table-sort/wf-table.component';
import { GenericModalService } from '../../../services/generic-modal.service';
import { MetadataStructureModalComponent } from './metadata-structure-modal/metadata-structure-modal.component';
import { BusinessProcessService } from '../../../services/business-process.service';
import {MetadataService} from '../../../services/configuration/metadata.service';
import {EnumTranslateService} from '../../../services/enumTranslate-service';

@Component({
  selector: 'app-metadata-structure-list',
  templateUrl: './metadata-structure-list.component.html',
  styleUrls: ['./metadata-structure-list.component.css']
})
export class MetadataStructureListComponent implements OnInit {

  filteredMetadataList = [];
  metadataList: any[];
  pleaseWait = false;
  errorMessage: string;
  modalComponent: any = MetadataStructureModalComponent;
  hasRight: boolean;
  filterSettings = {
    placeholder: 'Filtrar',
    width: 100,
    inputTextSearchId: 'txtSearchMetadata',
    showBooleanFilter: false,
    textFilterPropertyNames: ['name', 'typeDescription', 'editingTypeDescription'],
    booleanTrueResult: true
  };
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private metadataService: MetadataService,
    private modalService: GenericModalService,
    private businessProcessService: BusinessProcessService
  ) { }

  ngOnInit() {
    this.getAllMetadataStructure();
    this.checkRights();
  }

  getAllMetadataStructure() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.metadataService.getAllMetadataStructures()
      .subscribe( list => {
        list.forEach(c => {
          c.typeDescription = EnumTranslateService.getEnumMetadataType(c.type);
          c.editingTypeDescription = EnumTranslateService.getEnumMetadataEditingType(c.editingBy);
        });

        this.filteredMetadataList = list;
        this.metadataList = list;
        this.pleaseWait = false;
      }, error1 => { this.errorMessage = error1; this.pleaseWait = false; });
  }

  onAddNew() {
    if (this.hasRight) {
      const newMetadataStructure = { };
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Criar estrutura de metadado', newMetadataStructure);
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onEdit(metadataStructure: any) {
    if (this.hasRight) {
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Editar estrutura de metadado', metadataStructure);
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onDelete(metadataStructure: any) {
    if (this.hasRight) {
      this.errorMessage = '';
      let alert: any;
      alert = this.modalService
        .showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão da estrutura de metadado?');
      alert.then( resp => {
        if (resp.value) {
          this.metadataService.deleteMetadataStructure(metadataStructure)
            .subscribe( () => {
                this.ngOnInit();
              },
              error1 => {
                this.errorMessage = error1;
              });
        }
      });
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }


  checkRights() {
    this.errorMessage = '';
    this.businessProcessService.checkRights(4194304)
      .subscribe( rights => {
        this.hasRight = rights.length > 0;
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  onFilterList(filteredData: any[]) {
    this.filteredMetadataList = filteredData;
  }

}
